// Currencies data with symbols and names
export const currencies = [
  // Major/Popular Currencies
  { code: 'INR', symbol: '₹', name: 'Indian Rupee', rate: 1 },
  { code: 'USD', symbol: '$', name: 'US Dollar', rate: 0.012 },
  { code: 'EUR', symbol: '€', name: 'Euro', rate: 0.011 },
  { code: 'GBP', symbol: '£', name: 'British Pound', rate: 0.0095 },
  { code: 'JPY', symbol: '¥', name: 'Japanese Yen', rate: 1.8 },
  { code: 'AUD', symbol: 'A$', name: 'Australian Dollar', rate: 0.018 },
  
  // All Other Currencies
  { code: 'CAD', symbol: 'C$', name: 'Canadian Dollar', rate: 0.016 },
  { code: 'SGD', symbol: 'S$', name: 'Singapore Dollar', rate: 0.016 },
  { code: 'CNY', symbol: '¥', name: 'Chinese Yuan', rate: 0.086 },
  { code: 'CHF', symbol: 'CHF', name: 'Swiss Franc', rate: 0.011 },
  { code: 'NZD', symbol: 'NZ$', name: 'New Zealand Dollar', rate: 0.020 },
  { code: 'HKD', symbol: 'HK$', name: 'Hong Kong Dollar', rate: 0.094 },
  { code: 'SEK', symbol: 'kr', name: 'Swedish Krona', rate: 0.13 },
  { code: 'NOK', symbol: 'kr', name: 'Norwegian Krone', rate: 0.13 },
  { code: 'DKK', symbol: 'kr', name: 'Danish Krone', rate: 0.082 },
  { code: 'PLN', symbol: 'zł', name: 'Polish Zloty', rate: 0.048 },
  { code: 'MXN', symbol: '$', name: 'Mexican Peso', rate: 0.20 },
  { code: 'BRL', symbol: 'R$', name: 'Brazilian Real', rate: 0.060 },
  { code: 'ZAR', symbol: 'R', name: 'South African Rand', rate: 0.22 },
  { code: 'RUB', symbol: '₽', name: 'Russian Ruble', rate: 1.1 },
  { code: 'TRY', symbol: '₺', name: 'Turkish Lira', rate: 0.39 },
  { code: 'AED', symbol: 'AED', name: 'UAE Dirham', rate: 0.044 },
  { code: 'SAR', symbol: 'SAR', name: 'Saudi Riyal', rate: 0.045 },
  { code: 'QAR', symbol: 'QAR', name: 'Qatari Riyal', rate: 0.044 },
  { code: 'KWD', symbol: 'KWD', name: 'Kuwaiti Dinar', rate: 0.0037 },
  { code: 'OMR', symbol: 'OMR', name: 'Omani Rial', rate: 0.0046 },
  { code: 'BHD', symbol: 'BHD', name: 'Bahraini Dinar', rate: 0.0045 },
  { code: 'THB', symbol: '฿', name: 'Thai Baht', rate: 0.43 },
  { code: 'MYR', symbol: 'RM', name: 'Malaysian Ringgit', rate: 0.056 },
  { code: 'IDR', symbol: 'Rp', name: 'Indonesian Rupiah', rate: 190 },
  { code: 'PHP', symbol: '₱', name: 'Philippine Peso', rate: 0.67 },
  { code: 'KRW', symbol: '₩', name: 'South Korean Won', rate: 16 },
  { code: 'TWD', symbol: 'NT$', name: 'Taiwan Dollar', rate: 0.38 },
  { code: 'HUF', symbol: 'Ft', name: 'Hungarian Forint', rate: 4.3 },
  { code: 'CZK', symbol: 'Kč', name: 'Czech Koruna', rate: 0.28 },
  { code: 'ILS', symbol: '₪', name: 'Israeli Shekel', rate: 0.044 },
  { code: 'CLP', symbol: '$', name: 'Chilean Peso', rate: 11 },
  { code: 'ARS', symbol: '$', name: 'Argentine Peso', rate: 10 },
  { code: 'COP', symbol: '$', name: 'Colombian Peso', rate: 47 },
  { code: 'PEN', symbol: 'S/', name: 'Peruvian Sol', rate: 0.045 },
  { code: 'EGP', symbol: '£', name: 'Egyptian Pound', rate: 0.37 },
  { code: 'NGN', symbol: '₦', name: 'Nigerian Naira', rate: 9.5 },
  { code: 'PKR', symbol: 'Rs', name: 'Pakistani Rupee', rate: 3.3 },
  { code: 'BDT', symbol: '৳', name: 'Bangladeshi Taka', rate: 1.3 },
  { code: 'LKR', symbol: 'Rs', name: 'Sri Lankan Rupee', rate: 3.6 },
  { code: 'NPR', symbol: 'Rs', name: 'Nepalese Rupee', rate: 1.6 },
  { code: 'MMK', symbol: 'K', name: 'Myanmar Kyat', rate: 25 },
  { code: 'VND', symbol: '₫', name: 'Vietnamese Dong', rate: 300 },
];

// Suggested currencies (first 6)
export const suggestedCurrencies = currencies.slice(0, 6);

// All other currencies
export const allCurrencies = currencies.slice(6);

// Get currency by code
export const getCurrencyByCode = (code) => {
  return currencies.find(currency => currency.code === code) || currencies[0];
};

// Default currency
export const defaultCurrency = currencies[0];

